<template>
  <div class="w-100 list-group mb-3  bg-white">
    <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
      <div class="fw-bold  my-0 lh-base h6" >个人中心 / 青年科学家招募</div>
      <button class="btn btn-primary btn-sm" @click="goto">招募计划介绍</button>
    </div>

    <LoadingCom :show="showLoading"></LoadingCom>

<!--    横形线-->
    <div class="w-100 py-5 px-3 mt-5 overflow-x-auto" v-if="!showLoading">
      <ul class="timeline-inner-box-horizontal d-flex mt-5  align-items-center">
        <li class="position-relative timeline-inner-box active" :class="{'active':hasApplyRecord}">
          <div class="position-relative title-box ">
           在线申请
          </div>
          <div class="position-relative state-box d-flex align-items-center justify-content-center flex-column">
            <span class="badge title-badge text-bg-secondary  rounded-pill   flex-shrink-0" v-if="!hasApplyRecord">未提交</span>
            <span class="badge title-badge badge-little-lightblue rounded-pill   flex-shrink-0" v-if="hasApplyRecord">已提交</span>
            <a class="btn-link text-primary text-decoration-none small point-curser mt-3" @click="gotoDetailPage" v-if="hasApplyRecord">查看详情</a>
            <a class="btn-link text-primary text-decoration-none small point-curser mt-3"  v-if="!hasApplyRecord">提交申请</a>
          </div>
        </li>
       <li class="position-relative timeline-inner-box" v-for="(item,index) of list" :key="index" :class="{'active':Progress>=item.progress}">
         <div class="position-relative title-box ">
           {{item.stepName}}
         </div>
         <div class="position-relative state-box d-flex align-items-center justify-content-center flex-column">
<!--            在线申请-->
<!--           <span class="badge title-badge text-bg-secondary  rounded-pill   flex-shrink-0" v-if="item.index===1 && item.status<0">未提交</span>-->
<!--           <span class="badge title-badge badge-little-lightblue rounded-pill   flex-shrink-0" v-if="item.index===1 && item.status>-1">已提交</span>-->
<!--           <a class="btn-link text-primary text-decoration-none small point-curser mt-3" v-if="item.index===1 && item.status>-1">查看详情</a>-->
<!--           <a class="btn-link text-primary text-decoration-none small point-curser mt-3" v-if="item.index===1 && item.status==-1">提交申请</a>-->
<!--           项目受理-签署合作协议-->
<!--           <span class="badge title-badge text-bg-secondary  rounded-pill   flex-shrink-0" v-if="item.status===0">未开始</span>-->
           <span class="badge title-badge badge-blue-green rounded-pill   flex-shrink-0" v-if="item.status===0 && (item.progress<=Progress)">进行中</span>
           <span class="badge title-badge text-bg-secondary  rounded-pill   flex-shrink-0" v-if="item.status===0 && (item.progress>Progress)">未开始</span>
           <span class="badge title-badge badge-little-lightblue rounded-pill   flex-shrink-0" v-if="item.status===1">已完成</span>
           <span class="badge title-badge badge-red-blue rounded-pill   flex-shrink-0" v-if="item.status===2">未通过原因</span>
           <a class="btn-link text-danger-red text-decoration-none small point-curser mt-3 " v-if="item.status===2" @click="showReason(item)">原因</a>
         </div>
       </li>
<!--        补全最后一个-->
        <li class="position-relative timeline-inner-box" :class="{'active':Progress>=5}">

        </li>

      </ul>

    </div>
<!--    竖直线-->
<!--    <div class="d-flex justify-content-center py-4">-->
<!--      <ul class="timeline-inner-box-vertical ">-->
<!--        <li class="position-relative timeline-inner-box" :class="{'error':item.state===3,'success':item.state===2}" v-for="(item,index) of list" :key="index">-->
<!--          <div class="item-title fw-bold position-relative">-->
<!--            {{item.stepName}}-->
<!--          </div>-->
<!--          <div class="item-states my-2">-->
<!--            未提交-->
<!--            {{getStateDist(index,item.state,3)}}-->
<!--          </div>-->
<!--          <a class="item-btn-add my-2 point-curser" v-if="item.index===1 && state==0">-->
<!--            提交申请-->
<!--          </a>-->
<!--          <a class="item-btn my-2 point-curser" v-if="item.state===3">-->
<!--            查看原因-->
<!--          </a>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>

  <!--  查看原因-->
  <div class="modal fade" ref="centerResonModel" id="centerResonModel" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered  modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title fw-bold" >未通过</div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pub-word-breakAll text">
          {{Notes || "原因未知"}}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="callbackState">关闭</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>

import LoadingCom from "@/layout/LoadingCom"
import {computed, onBeforeUnmount, onMounted, ref, watch} from "vue";
import router from "@/router";
import {loginModelOpen} from "@/utils/authCheck";
import {getSciApplyDetail} from "@/api/scientist";
import store from "@/store";
import {Modal} from "bootstrap";
const hasApplyRecord = ref(false) // 是否有记录
const detail = ref({}) // 详细信息
const isLogin = computed(()=>store.state.loginModel.login)
//Progress int // 申请进度。0 未开始，1 项目受理，2 项目评审，3 候选人背调，4 签署项目任务书，5 签署“青年科学家”合作协议 -1 未开始
//Status int // 审核状态。0 未审批，1 已通过，2 已拒绝
const list = ref([
  // {stepName:"在线申报",progress:0,status:0,className:""}, //在线申报单独处理
  {stepName:"项目受理",progress:1,status:0,className:""},
  {stepName:"项目评审",progress:2,status:0,className:""},
  {stepName:"候选人背调",progress:3,status:0,className:""},
  {stepName:"签署项目任务书",progress:4,status:0,className:""},
  {stepName:'签署合作协议',progress:5,status:0,className:""},
])
let resonModelRef = "" // 原因模态框 实例
const centerResonModel = ref()// 原因模态框 dom
const Notes = ref() // 保存拒绝原因
const Progress = ref(-1)
const Status = ref(-1)
watch(() => store.state.loginModel.login,(now, prev) => {
  if(now){
    getDetail && getDetail() // 获取当前用户的信息
  }
},{ deep: true})
const goto = () => {
  router.push({path:"/scientist"})
}
const getDetail =async ()=>{
  if(!isLogin.value){
    return loginModelOpen(true)
  }
  showLoading.value = true
  const res = await getSciApplyDetail()
  showLoading.value = false
  if(res.err_code==0 && res.data && res.data.ID){
    hasApplyRecord.value = true
    detail.value = res.data
    Progress.value = res.data.Progress
    Status.value = res.data.Status
    Notes.value = res.data.Notes
    list.value.forEach(item=>{
      if(item.progress<Progress.value){ // 已经经历过的
        item.status = 1 // 已通过
      }else if(item.progress>Progress.value){ // 未到的
        item.status = 0 // 未审批
      }else{ //当前步骤，状态给当前步骤的状态
        item.status = Status
      }
    })
  }else{
    Progress.value = -1
    list.value = [
      {stepName:"在线申报",progress:0,status:-1,className:""}, //0 未审批，1 已通过，2 已拒绝，前端加
      {stepName:"项目受理",progress:1,status:0,className:""},
      {stepName:"项目评审",progress:2,status:0,className:""},
      {stepName:"候选人背调",progress:3,status:0,className:""},
      {stepName:"签署项目任务书",progress:4,status:0,className:""},
      {stepName:'签署合作协议',progress:5,status:0,className:""},
    ]
    hasApplyRecord.value = false
  }
}


const showLoading = ref(true)
onMounted(()=>{
  getDetail()
})
onBeforeUnmount(()=>{
  if(resonModelRef){
    resonModelRef.hide()
  }
})
const gotoDetailPage = ()=>{
  router.push({path:"/scientistApply"})
}
// 展示原因
const showReason = (item)=>{
  if(!resonModelRef){
    resonModelRef = new Modal(centerResonModel.value);
  }
  resonModelRef.show()
}
</script>



<style lang="scss" scoped>
$borderSize:13px;
$normalC: #c8c8c8;
$normalActive: #39bdfb;
$normalCPassed: #40fd01;
$normalCError: red;

//竖直
.timeline-inner-box-vertical{
  .item-title{
    top:-4px;
    color:$normalC;
  }
  .item-states{
   color:$normalC;
    font-size: 0.8rem;
  }
  .item-btn{
    color:#0a53be;
    font-size: 0.8rem;
    text-decoration: underline;
    display: block;
  }
  .item-btn-add{
    color:#0a53be;
    font-size: 0.8rem;
    text-decoration: underline;
    display: block;
  }
  .timeline-inner-box{
    border-left: 1px solid $normalC;
    padding: 0 20px 50px 20px ;
  }
  .timeline-inner-box:after{
    content: "";
    display: block;
    position: absolute;
    width: $borderSize;
    height: $borderSize;
    background: $normalC;
    border-radius: 50%;
    left: 0;
    top:0;
    transform:translateX(-50%) translateY(-50%);
  }
  .timeline-inner-box.error{
    .item-title,.item-states,.item-btn{
      color:$normalCError !important;
    }
    &{
      border-left: 1px solid $normalCError !important;
    }
    &:after{
      background: $normalCError !important;
    }

  }
  .timeline-inner-box.active{
    .item-title,.item-states,.item-btn{
      color:$normalActive !important;
    }
    &{
      border-left: 1px solid $normalActive !important;
    }
    &:after{
      background: $normalActive !important;
    }
  }
  .timeline-inner-box.success{
    .item-title,.item-states,.item-btn{
      color:$normalCPassed !important;
    }
    &{
      border-left: 1px solid $normalCPassed !important;
    }
    &:after{
      background: $normalCPassed !important;
    }
  }
}
// 横向
.timeline-inner-box-horizontal{
  .timeline-inner-box{
    border-top: 2px solid $normalC;
    flex: 1;
    height: 140px;
    //width: 14.2%;
    min-width: 120px;
    max-width: 100px;
  }
  //
  //.timeline-inner-box:first-child{
  //  border-top: none;
  //}

  .timeline-inner-box:not(:last-child):after{
    content: "";
    display: block;
    position: absolute;
    width: 10px;
    height: 10px;
    background: #fff;
    border-radius: 50%;
    border: 2px solid $normalC;
    right: 0;
    top:0;
    z-index: 10;
    transform:translateX(50%) translateY(-50%);
  }
  .title-box{
    top:-30px;
    //width: 8rem;
    text-align: center;
    //background: red;
    right: -5px;
    transform:translateX(50%) translateY(0);
  }
  .title-badge{
    height: 1.2rem;
    line-height: 0.8rem;
    font-weight: normal;
    //width: 4rem;/
    text-align: center;
  }
  .small-text{
    font-size: 0.7rem;
  }
  .state-box{
    //width: 8rem;
    text-align: center;
    //background: red;
    right: -5px;
    transform:translateX(50%) translateY(0);
    z-index: 10;
  }
  .timeline-inner-box.active{
    border-top: 2px solid $normalActive;;
     &:after{
       border: 2px solid $normalActive;
     }
  }
  .timeline-inner-box.error{
    border-top: 2px solid $normalActive;;
    &:after{
      border: 2px solid $normalActive;
    }
  }
  .timeline-inner-box.success{
    border-top: 2px solid $normalActive;;
    &:after{
      border: 2px solid $normalActive;
    }
  }
}

</style>
